module.exports = __webpack_public_path__ + "img/60.status_toilet_paper.f7f92cc8.svg";